module.exports = __webpack_public_path__ + "img/hero-mobile.601bf3b4.png";